import { regions } from "~/application/countries"

export const planTypes = [
  {
    value: "lira",
    label: "LIRA",
  },
  {
    value: "lrsp",
    label: "LRSP",
  },
  {
    value: "lif",
    label: "LIF, RLIF, RRIF, RIF, LRIF or PRIF",
  },
  {
    value: "rpp",
    label: "Union or Employer Pension Plan",
    description: "Also known as a Registered Pension Plan (RPP)",
  },
  {
    value: "rlsp",
    label: "RLSP",
  },
  {
    value: "rrsp",
    label: "RRSP",
  },
  {
    value: "cpp",
    label: "Canada Pension Plan (CPP)",
  },
  {
    value: "oas",
    label: "Old Age Security (OAS)",
  },
  {
    value: "disability",
    label: "Disability Insurance Plan",
  },
  {
    value: "annuity",
    label: "Life Annuity",
  },
  {
    value: "insurance-settlement",
    label: "Insurance Settlement",
  },
  {
    value: "not-sure",
    label: "I'm not sure",
  },
  {
    value: "other",
    label: "Other",
  },
]

export const planReasons = [
  {
    value: "stopped-working",
    label: "I stopped working for the employer",
  },
  {
    value: "divorce-settlement",
    label: "Divorce Settlement",
  },
  {
    value: "death-spouse",
    label: "Death of Spouse",
  },
  {
    value: "other",
    label: "Other",
  },
]

export const planLocations = [
  {
    value: "bank",
    label: "Bank",
  },
  {
    value: "investment-firm",
    label: "Investment Firm",
  },
  {
    value: "employer-union",
    label: "Employer or Union",
  },
  {
    value: "government",
    label: "The Government",
  },
  {
    value: "other",
    label: "Other",
  },
]

export const liraProvinces = [
  ...regions["CA"].filter(({ value }) => value !== "PE"),
  { value: "not-sure", label: "I'm not sure" },
]

export const hearFromUs = [
  {
    value: "google",
    label: "Google",
  },
  {
    value: "kijiji",
    label: "Kijiji",
  },
  {
    value: "friends-family",
    label: "Friends / Family",
  },
  {
    value: "facebook",
    label: "Facebook",
  },
  {
    value: "national-post",
    label: "National Post",
  },
  {
    value: "toronto-star",
    label: "Toronto Star",
  },
  {
    value: "ottawa-sun",
    label: "Ottawa Sun",
  },
  {
    value: "winnipeg-sun",
    label: "Winnipeg Sun",
  },
  {
    value: "vancouver-sun",
    label: "Vancouver Sun",
  },
  {
    value: "edmonton-sun",
    label: "Edmonton Sun",
  },
  {
    value: "calgary-sun",
    label: "Calgary Sun",
  },
  {
    value: "toronto-sun",
    label: "Toronto Sun",
  },
  {
    value: "globe-mail",
    label: "Globe and Mail",
  },
  {
    value: "chronicle-hrald",
    label: "The Chronicle Herald",
  },
  {
    value: "other",
    label: "Other",
  },
]
